import { Card, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { createTheme } from "react-data-table-component";
import Layout from "../../../layout/default";
import Block from "../../../components/Block/Block";
import { Icon } from "../../../components";
import DataTable from "react-data-table-component";
import { useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import axios from "axios";
import api from "../../../services/auth/api";

// const baseURL = "http://127.0.0.1:8000/api/";

function ProductList() {
  const [listData, setListData] = useState([]);
  const [page, setPage] = useState(0);
  const countPerPage = 5;
  const [totalRows, setTotalRows] = useState(0);
  const [loading, setLoading] = useState(false);

  const _params = { params: {} };

  const getList = () => {
    setLoading(true);
    api.get(`${process.env.REACT_APP_HOST}api/product-variant-get-all-paginated`, _params)
      .then((response) => {
        setListData(response.data.data.data);
        setTotalRows(response.data.data.pagination.total);
      })
      .catch(() => {
        setListData([]);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    getList();
  }, [page]);

  const navigate = useNavigate();
  const handleView = (_id) => {
    navigate(`/shop/admin/product-variant-view/${_id}`);
  };

  const handleEdit = (_id) => {
    navigate(`/shop/admin/product-variant-edit/${_id}`); // Make sure this route exists
  };

  const deleteError = () => {
    Swal.fire({
      icon: "error",
      title: "Delete attempt was not successful",
      text: "Something went wrong!",
    });
  };

  const deleteConfirm = (_id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "It will delete permanently!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        api.delete(`${process.env.REACT_APP_HOST}api/product-variant/${_id}`)
          .then((response) => {
            if (response.data.success) {
              getList();
              Swal.fire("Deleted", "You successfully deleted this record", "success");
            } else {
              deleteError();
            }
          })
          .catch(deleteError);
      }
    });
  };

  const createProduct = (productData) => {
    const token = "${token}"; // Replace with your actual token
    axios.post(`${process.env.REACT_APP_HOST}api/product/create`, productData, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      }
    })
      .then(() => {
        Swal.fire('Success', 'Product created successfully', 'success');
        getList(); // Refresh the list after creation
      })
      .catch(() => {
        Swal.fire('Error', 'Failed to create product', 'error');
      });
  };

  createTheme("solarized", {
    text: {
      primary: "#004b8e",
      secondary: "#2aa198",
    },
    background: {
      default: "#fff",
    },
    context: {
      background: "#cb4b16",
      text: "#FFFFFF",
    },
    divider: {
      default: "#d3d3d3",
    },
    action: {
      button: "rgba(0,0,0,.54)",
      hover: "rgba(0,0,0,.02)",
      disabled: "rgba(0,0,0,.12)",
    },
  });

  const customStyles = {
    rows: {
      style: {
        minHeight: "45px",
      },
    },
    headCells: {
      style: {
        backgroundColor: "#1e67a8",
        color: "#fff",
        fontSize: "14px",
        paddingLeft: "8px",
        paddingRight: "8px",
      },
    },
    cells: {
      style: {
        paddingLeft: "8px",
        paddingRight: "8px",
      },
    },
  };

  const productListDataColumns = [
    {
      name: "action",
      cell: (row) => (
        <div className="text-start w-100">
          <Button variant="primary" size="sm" onClick={() => handleView(row.id)}>View</Button>
          <Button variant="primary" size="sm" className="ms-2" onClick={() => handleEdit(row.id)}>Edit</Button>
          <Button variant="danger" size="sm" onClick={() => deleteConfirm(row.id)} className="ms-2">Delete</Button>
        </div>
      ),
      sortable: false,
      hide: "md",
    },
    {
      name: "Title",
      selector: (row) => row.title,
      cell: (row) => <span>{row.title}</span>,
      sortable: true,
      hide: "md",
    },
    {
      name: "Description",
      selector: (row) => row.description,
      cell: (row) => <span>{row.description}</span>,
      sortable: true,
      hide: "md",
    },
    {
      name: "Price",
      selector: (row) => row.price,
      cell: (row) => <span>{row.price}</span>,
      sortable: true,
      hide: "md",
    },
    {
      name: "Discount",
      selector: (row) => row.discount,
      cell: (row) => <span>{row.discount}</span>,
      sortable: true,
      hide: "md",
    },
    {
      name: "Unit",
      selector: (row) => row.unit_id,
      cell: (row) => <span>{row.unit_id}</span>,
      sortable: true,
      hide: "md",
    },
    {
      name: "Unit Quantity",
      selector: (row) => row.unit_quantity,
      cell: (row) => <span>{row.unit_quantity}</span>,
      sortable: true,
      hide: "md",
    },
    
  ];

  return (
    <Layout title="Product Variant List">
      <Block.Head>
        <Block.HeadBetween>
          <Block.HeadContent>
            <ul className="d-flex">
              <li>
                <Link
                  to="/shop/admin/admin-panel"
                  className="btn btn-primary btn-md d-md-none"
                >
                  <span>Go To Panel</span>
                </Link>
              </li>
              <li>
                <Link
                  to="/shop/admin/admin-panel"
                  className="btn btn-primary d-none d-md-inline-flex"
                >
                  <span>Go To Panel</span>
                </Link>
              </li>
            </ul>
          </Block.HeadContent>
          <Block.HeadContent>
            <Block.Title tag="h2">Product Variant List</Block.Title>
          </Block.HeadContent>
          <Block.HeadContent>
            {/* <ul className="d-flex">
              <li>
                <Link to="/shop/admin/product-variant" className="btn btn-primary btn-md d-md-none">
                  <Icon name="plus" />
                  <span>Create</span>
                </Link>
              </li>
              <li>
                <Link to="/shop/admin/product-variant" className="btn btn-primary d-none d-md-inline-flex">
                  <Icon name="plus" />
                  <span>Create</span>
                </Link>
              </li>
            </ul> */}
          </Block.HeadContent>
        </Block.HeadBetween>
      </Block.Head>

      <Block>
        <Card>
          <DataTable
            tableClassName="data-table-head-light table-responsive"
            columns={productListDataColumns}
            data={listData}
            highlightOnHover
            pagination
            paginationServer
            paginationTotalRows={totalRows}
            paginationPerPage={countPerPage}
            paginationComponentOptions={{
              noRowsPerPage: true,
            }}
            onChangePage={(page) => setPage(page - 1)}
            progressPending={loading}
            theme="solarized"
            customStyles={customStyles}
          />
        </Card>
      </Block>
    </Layout>
  );
}

export default ProductList;
